/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictCategoryResource
 */
export interface PredictCategoryResource {
    /**
     * 
     * @type {string}
     * @memberof PredictCategoryResource
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof PredictCategoryResource
     */
    categoryLabel: string;
    /**
     * 
     * @type {string}
     * @memberof PredictCategoryResource
     */
    familyId: string;
}

/**
 * Check if a given object implements the PredictCategoryResource interface.
 */
export function instanceOfPredictCategoryResource(value: object): value is PredictCategoryResource {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('categoryLabel' in value) || value['categoryLabel'] === undefined) return false;
    if (!('familyId' in value) || value['familyId'] === undefined) return false;
    return true;
}

export function PredictCategoryResourceFromJSON(json: any): PredictCategoryResource {
    return PredictCategoryResourceFromJSONTyped(json, false);
}

export function PredictCategoryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictCategoryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
        'categoryLabel': json['categoryLabel'],
        'familyId': json['familyId'],
    };
}

export function PredictCategoryResourceToJSON(value?: PredictCategoryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'categoryId': value['categoryId'],
        'categoryLabel': value['categoryLabel'],
        'familyId': value['familyId'],
    };
}

